import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { theme } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";

// More Button
const moreButton: CSSProperties = {
  width: "100%",
  textAlign: "left",
  textTransform: "unset",
  fontFamily: fontFamilySans,
};

const moreIcon: CSSProperties = {
  color: theme.textSecondary,
  fill: theme.textSecondary,
  margin: 0,
  transition: "transform 0.4s",
};

const moreIconLess: CSSProperties = {
  color: theme.textSecondary,
  fill: theme.textSecondary,
  margin: 0,
  transform: "rotate(180deg)",
  transition: "transform 0.4s",
};

export const styles = {
  moreButton,
  moreIcon,
  moreIconLess,
};
